import React, { Component } from 'react';
import Navbar from './mycomponents/navbar';
import ViewCourseStudentsBody from './mycomponents/viewcoursestudentsbody';

class ViewCourseStudents extends Component {
    state = {  } 
    render() { 
        return (
            <React.Fragment>
            <Navbar/>
            <ViewCourseStudentsBody />
                </React.Fragment>
        );
    }
}
 
export default ViewCourseStudents;